import { FC } from 'react';
import Input, { TInputEventHandle } from '../form/Input';
import { INewRole } from '../../model/IRole';
import { IZodErrorsState } from '../../utils/checkFormStateByZod';
import useClickByKey from '../../hooks/useClickByKey';
import Alert from '../common/alert/Alert';
import Button from '../form/Button';
import TicketTypeMultiSearchField from '../tickets/TicketTypeMultiSearchField';

const RoleItemForm: FC<{
  isPending?: boolean,
  form: INewRole,
  handle: (key: keyof INewRole) => TInputEventHandle,
  handleRole: () => unknown,
  errState?: Partial<IZodErrorsState<INewRole>>,
  btnTitle?: string,
  mode?: 'edit' | 'add',
}> = ({
  form,
  isPending = false,
  handle,
  errState,
  handleRole,
  btnTitle,
  mode = 'add',
}) => {
    const { btnRef, onKeyUp } = useClickByKey();

    return (
      <div className={`flex flex-col gap-2 ${isPending ? 'animate-pulse' : ''}`}>
        <Input
          label='Name'
          name="name"
          size="large"
          value={form.name}
          handle={handle('name')}
          error={errState?.name}
          description="Role Name e.g. Accounting"
          disabled={isPending || mode === 'edit'}
          onKeyUp={onKeyUp}
        />
        <Input
          label='Description'
          name="description"
          size="large"
          value={form.description}
          handle={handle('description')}
          error={errState?.description}
          description="Role Description e.g. Role for managers"
          disabled={isPending}
          onKeyUp={onKeyUp}
        />
        <TicketTypeMultiSearchField
          label="Ticket Types"
          name="ticketTypes"
          placeholder='Assigned Ticket Types'
          value={String(form.ticketTypes)}
          handle={handle('ticketTypes')}
          className='col-span-12'
          disabled={isPending}
        />

        <div className="flex gap-2 pt-4">
          <div className="flex-1">
            {!!errState?.totalError && (
              <Alert>
                {errState?.totalError}
              </Alert>
            )}
          </div>
          <div className=""></div>
          <Button
            btnRef={btnRef}
            type="submit"
            size="large"
            onClick={handleRole}
            isNotFullWidth
            disabled={isPending}
          >
            {btnTitle}
          </Button>
        </div>
      </div>
    );
  }

export default RoleItemForm;
